import { render, staticRenderFns } from "./AreaHome.vue?vue&type=template&id=69358bc5&"
import script from "./AreaHome.vue?vue&type=script&lang=js&"
export * from "./AreaHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports